module.exports = __webpack_public_path__ + "media/images/pic/chess-ef68ebe8fd36fba88b9e9093f7126466.jpg";